import React, { useState, useEffect } from 'react';
import { types } from '../../../../redux/types';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Box, Grid } from '@mui/material';
import FieldText from '../../../components/general/fields/fieldText';
import {
    asyncPatchSurvey,
    asyncPostSurvey,
} from '../../../../services/survey.service';
import { SwalCustomClass } from '../../../components/general/toastSwal/swalCustomClass';
import { MasterMessage } from '../../../../masters/masterMessages';
import { useNavigate } from 'react-router-dom';
import { SURVEYEDIT } from '../../../../routes/paths';

type Props = {
    idSurvey?: any;
    surveyInfo?: any;
    onSubmitSave: (value: boolean) => void;
    saveInfo?: any;
    onSave: (value: boolean) => void;
};

const SurveyInformation = ({
    idSurvey,
    surveyInfo,
    onSubmitSave,
    saveInfo,
    onSave,
}: Props) => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { surveys }: any = MasterMessage;
    const [submit, setSubmit] = useState<boolean>(false);

    const formik = useFormik({
        initialValues: {
            code: idSurvey ? surveyInfo?.code : '',
            title: idSurvey ? surveyInfo?.title : '',
            description: idSurvey ? surveyInfo?.description : '',
            status: idSurvey ? surveyInfo?.status : 'in process',
        },
        validationSchema: Yup.object({
            code: Yup.string().required('El código es obligatorio'),
            title: Yup.string().required('El titulo es obligatorio'),
            description: Yup.string().required('La descripción es obligatoria'),
        }),
        onSubmit: async (formSurveyInfo) => {
            setSubmit(true);
            if (!idSurvey) {
                const body: any = await asyncPostSurvey(formSurveyInfo).finally(
                    () => setSubmit(false)
                );
                if (body?.items !== undefined) {
                    navigate(`${SURVEYEDIT}/${body.items.id}`);
                    dispatch({ type: types.nextStepper });
                } else {
                    SwalCustomClass.fire({
                        text: surveys[body.message],
                        icon: 'error',
                        iconColor: '#1d1d1d',
                    });
                }
            } else {
                asyncPatchSurvey(idSurvey, formSurveyInfo)
                    .then((body: any) => {
                        if (body?.items !== undefined) {
                            onSave(true);
                            dispatch({ type: types.nextStepper });
                            window.setTimeout(() => {
                                onSave(false);
                            }, 500);
                        } else {
                            SwalCustomClass.fire({
                                text: surveys[body.message],
                                icon: 'error',
                                iconColor: '#1d1d1d',
                            });
                        }
                    })
                    .finally(() => setSubmit(false));
            }
        },
    });

    useEffect(() => {
        onSubmitSave(submit);
        saveInfo(() => formik.handleSubmit);
    }, [submit]);

    return (
        <>
            <Box>
                <Grid
                    container
                    spacing={{ xs: 1.5, md: 1.5 }}
                    columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                >
                    <Grid item xs={12} md={6}>
                        <FieldText
                            label="Código Encuesta"
                            name="code"
                            size="small"
                            required={true}
                            touched={formik.touched.code}
                            errors={formik.errors.code}
                            value={formik.values.code}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FieldText
                            label="Titulo Encuesta"
                            name="title"
                            size="small"
                            required={true}
                            touched={formik.touched.title}
                            errors={formik.errors.title}
                            value={formik.values.title}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FieldText
                            label="Descripcion Encuesta"
                            name="description"
                            required={true}
                            rows={5}
                            touched={formik.touched.description}
                            errors={formik.errors.description}
                            value={formik.values.description}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default SurveyInformation;
